export type DsrState = {
  name: string
  code?: string
  country?: string
}

export const dsrListUsStates: DsrState[] = [
  {
    name: 'Alabama',
    code: 'AL',
    country: 'US'
  },
  {
    name: 'Alaska',
    code: 'AK',
    country: 'US'
  },
  {
    name: 'American Samoa',
    code: 'AS',
    country: 'US'
  },
  {
    name: 'Arizona',
    code: 'AZ',
    country: 'US'
  },
  {
    name: 'Arkansas',
    code: 'AR',
    country: 'US'
  },
  {
    name: 'California',
    code: 'CA',
    country: 'US'
  },
  {
    name: 'Colorado',
    code: 'CO',
    country: 'US'
  },
  {
    name: 'Connecticut',
    code: 'CT',
    country: 'US'
  },
  {
    name: 'Delaware',
    code: 'DE',
    country: 'US'
  },
  {
    name: 'District Of Columbia',
    code: 'DC',
    country: 'US'
  },
  {
    name: 'Federated States Of Micronesia',
    code: 'FM',
    country: 'US'
  },
  {
    name: 'Florida',
    code: 'FL',
    country: 'US'
  },
  {
    name: 'Georgia',
    code: 'GA',
    country: 'US'
  },
  {
    name: 'Guam',
    code: 'GU',
    country: 'US'
  },
  {
    name: 'Hawaii',
    code: 'HI',
    country: 'US'
  },
  {
    name: 'Idaho',
    code: 'ID',
    country: 'US'
  },
  {
    name: 'Illinois',
    code: 'IL',
    country: 'US'
  },
  {
    name: 'Indiana',
    code: 'IN',
    country: 'US'
  },
  {
    name: 'Iowa',
    code: 'IA',
    country: 'US'
  },
  {
    name: 'Kansas',
    code: 'KS',
    country: 'US'
  },
  {
    name: 'Kentucky',
    code: 'KY',
    country: 'US'
  },
  {
    name: 'Louisiana',
    code: 'LA',
    country: 'US'
  },
  {
    name: 'Maine',
    code: 'ME',
    country: 'US'
  },
  {
    name: 'Marshall Islands',
    code: 'MH',
    country: 'US'
  },
  {
    name: 'Maryland',
    code: 'MD',
    country: 'US'
  },
  {
    name: 'Massachusetts',
    code: 'MA',
    country: 'US'
  },
  {
    name: 'Michigan',
    code: 'MI',
    country: 'US'
  },
  {
    name: 'Minnesota',
    code: 'MN',
    country: 'US'
  },
  {
    name: 'Mississippi',
    code: 'MS',
    country: 'US'
  },
  {
    name: 'Missouri',
    code: 'MO',
    country: 'US'
  },
  {
    name: 'Montana',
    code: 'MT',
    country: 'US'
  },
  {
    name: 'Nebraska',
    code: 'NE',
    country: 'US'
  },
  {
    name: 'Nevada',
    code: 'NV',
    country: 'US'
  },
  {
    name: 'New Hampshire',
    code: 'NH',
    country: 'US'
  },
  {
    name: 'New Jersey',
    code: 'NJ',
    country: 'US'
  },
  {
    name: 'New Mexico',
    code: 'NM',
    country: 'US'
  },
  {
    name: 'New York',
    code: 'NY',
    country: 'US'
  },
  {
    name: 'North Carolina',
    code: 'NC',
    country: 'US'
  },
  {
    name: 'North Dakota',
    code: 'ND',
    country: 'US'
  },
  {
    name: 'Northern Mariana Islands',
    code: 'MP',
    country: 'US'
  },
  {
    name: 'Ohio',
    code: 'OH',
    country: 'US'
  },
  {
    name: 'Oklahoma',
    code: 'OK',
    country: 'US'
  },
  {
    name: 'Oregon',
    code: 'OR',
    country: 'US'
  },
  {
    name: 'Palau',
    code: 'PW',
    country: 'US'
  },
  {
    name: 'Pennsylvania',
    code: 'PA',
    country: 'US'
  },
  {
    name: 'Puerto Rico',
    code: 'PR',
    country: 'US'
  },
  {
    name: 'Rhode Island',
    code: 'RI',
    country: 'US'
  },
  {
    name: 'South Carolina',
    code: 'SC',
    country: 'US'
  },
  {
    name: 'South Dakota',
    code: 'SD',
    country: 'US'
  },
  {
    name: 'Tennessee',
    code: 'TN',
    country: 'US'
  },
  {
    name: 'Texas',
    code: 'TX',
    country: 'US'
  },
  {
    name: 'Utah',
    code: 'UT',
    country: 'US'
  },
  {
    name: 'Vermont',
    code: 'VT',
    country: 'US'
  },
  {
    name: 'Virgin Islands',
    code: 'VI',
    country: 'US'
  },
  {
    name: 'Virginia',
    code: 'VA',
    country: 'US'
  },
  {
    name: 'Washington',
    code: 'WA',
    country: 'US'
  },
  {
    name: 'West Virginia',
    code: 'WV',
    country: 'US'
  },
  {
    name: 'Wisconsin',
    code: 'WI',
    country: 'US'
  },
  {
    name: 'Wyoming',
    code: 'WY',
    country: 'US'
  }
]
